import React, { FC } from 'react'
import { Element } from '../../../Element'

export const PresentationVideoPlayerYouTubeEmbed: FC<{
  youtubeEmbedUrl: string
}> = ({ youtubeEmbedUrl }) => (
  <Element component='PresentationVideoEmbed'>
    <iframe
      src={youtubeEmbedUrl}
      width='853'
      height='480'
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
      title='Embedded youtube'
      style={{
        left: 0,
        top: 0,
        width: '100%',
      }}
    />
  </Element>
)
